import React, { useEffect, useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import DrawingColorPicker, { DEFAULT_DRAWING_COLOR } from '../../components/DrawingColorPicker';
import { useCanvasDrawing } from '../../components/useCanvasDrawing';
import esqueleto from './teste.png';
import './style.css';

const ImagemAtendimento = ({ canvasRef, setImagemServidor, imagemServidor, register }) => {

  const [drawingColor, setDrawingColor] = useState(DEFAULT_DRAWING_COLOR);
  const { canvasHandlers, canUndo, saveUndoStep, discardUndoStepIfUnchanged, undo, resetUndo } = useCanvasDrawing(canvasRef, drawingColor);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d', { willReadFrequently: true }); // o Desfazer lê o desenho a cada alteração

    // Carregar a imagem de fundo
    const backgroundImage = new Image();
    backgroundImage.crossOrigin = "anonymous";
    backgroundImage.src = imagemServidor === null || imagemServidor === '' ? esqueleto : imagemServidor;

    backgroundImage.onload = () => {
      // Definir as dimensões do canvas para serem as mesmas da imagem
      canvas.width = backgroundImage.width;
      canvas.height = backgroundImage.height;

      // Desenhar a imagem de fundo no canvas
      context.drawImage(backgroundImage, 0, 0);

      // Riscos feitos antes de a imagem carregar foram apagados por ela: um traço em andamento termina e o Desfazer
      // começa daqui
      resetUndo();
    };
  }, []);

  // const clearDrawing = () => {
  //   const canvas = canvasRef.current;
  //   const context = canvas.getContext('2d');

  //   // Limpar apenas os riscos desenhados
  //   context.clearRect(0, 0, canvas.width, canvas.height);

  //   // Carregar a imagem de fundo novamente após limpar
  //   const backgroundImage = new Image();
  //   backgroundImage.crossOrigin = "anonymous";
  //   backgroundImage.src = esqueleto;
  //   backgroundImage.onload = () => {
  //     context.drawImage(backgroundImage, 0, 0);
  //   };
  // };

  const clearDrawing = () => {
    const undoStep = saveUndoStep(); // o Limpar marcações também pode ser desfeito

    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');

    // Limpar apenas os riscos desenhados
    context.clearRect(0, 0, canvas.width, canvas.height);

    // Carregar a imagem de fundo novamente após limpar
    const backgroundImage = new Image();
    backgroundImage.crossOrigin = "anonymous";
    backgroundImage.src = esqueleto;
    backgroundImage.onload = () => {
      canvas.width = backgroundImage.width;
      canvas.height = backgroundImage.height;
      context.drawImage(backgroundImage, 0, 0);
      discardUndoStepIfUnchanged(undoStep); // não havia nada para limpar
    };
  };

  const preventScroll = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    const canvas = canvasRef.current;

    canvas.addEventListener('touchstart', preventScroll, { passive: false });
    canvas.addEventListener('touchmove', preventScroll, { passive: false });
    canvas.addEventListener('touchend', preventScroll, { passive: false });

    return () => {
      canvas.removeEventListener('touchstart', preventScroll);
      canvas.removeEventListener('touchmove', preventScroll);
      canvas.removeEventListener('touchend', preventScroll);
    };
  }, []);

  return (
    <>
      <Form.Group className="d-flex flex-column justify-content-center align-items-center">
        <div className='mt-2 d-flex gap-3'>
          <Form.Label>Exame complementar</Form.Label>
        </div>
        <DrawingColorPicker value={drawingColor} onChange={setDrawingColor} />
        <canvas
          ref={canvasRef}
          {...canvasHandlers}
          style={{ border: '1px solid black' }}
        ></canvas>
        <div className='mt-2 d-flex gap-3'>
          <Button onClick={clearDrawing}>Limpar marcações</Button>
          <Button onClick={undo} disabled={!canUndo}>Desfazer</Button>
        </div>
      </Form.Group>

      <Form.Group className="col-12">
        <Form.Label>Observação</Form.Label>
        <Form.Control size='sm' as="textarea" rows={10} {...register('imagem_atendimento_observacao')} />
      </Form.Group>
    </>
  );
};

export default ImagemAtendimento;
